import { NavigateStoryProps } from './ampStoryPlayer.types';

export const getAmpCss = () => {
  const link = document.createElement('link');
  link.href = 'https://cdn.ampproject.org/amp-story-player-v0.css';
  link.id = 'amp-player-css';
  link.rel = 'stylesheet';
  return link;
};

export const navigateStory = ({
  direction,
  player,
  storyProgress,
}: NavigateStoryProps) => {
  return (event: Event) => {
    if (!player) {
      return;
    }

    /**
     * 0 = Same Story|Page, 1 = next, -1=previous
     * progress 0 //on first page of story
     * - next (0,1)
     * - prev (-1)
     *
     * progress 1 //on last page of story
     * - next (1)
     * - prev (0, -1)
     */
    let args = [0, 1];
    switch (storyProgress) {
      case 0:
        args = direction === 'previous' ? [-1] : [0, 1];
        break;
      case 1:
        args = direction === 'previous' ? [0, -1] : [1];
        break;
      default:
        args = direction === 'previous' ? [0, -1] : [0, 1];
    }

    if (player.isReady) {
      try {
        player.go(...args);

        // After switching story, rewind the story to first page
        if (args.length === 1) {
          player.rewind(0);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('[AmpStoryPlayer > navigateStory]', error);
      }
    }
  };
};
